import { useMemo } from 'react';
import { InferType } from 'yup';
import { createChangePasswordSchema } from './createChangePasswordSchema';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';

export function useChangePasswordSchema() {
	const { t } = useTranslation();

	return useMemo(() => createChangePasswordSchema(t), [t]);
}

export type ChangePasswordFormSchema = InferType<
	ReturnType<typeof useChangePasswordSchema>
>;
